import type { JSX } from 'react';
import {
  formatEventMetaLine,
  shippedViaLine,
  staffSummaryLine,
  tournamentDirectorLine,
  type PublicEvent,
} from '@inventohub/shared';

export function EventSummaryLines({
  event,
  testId,
}: {
  event: PublicEvent;
  testId?: string;
}): JSX.Element {
  const staff = staffSummaryLine(event.staffNames);
  const director = tournamentDirectorLine(event);
  const shipped = shippedViaLine(event.shippedVia);
  const prefix = testId ?? `event-summary-${event.id}`;
  return (
    <div className="event-summary" data-testid={prefix}>
      {staff ? (
        <p className="meta" data-testid={`${prefix}-staff`}>
          {staff}
        </p>
      ) : null}
      {director ? (
        <p className="meta" data-testid={`${prefix}-td`}>
          {director}
        </p>
      ) : null}
      {shipped ? (
        <p className="meta" data-testid={`${prefix}-shipped`}>
          {shipped}
        </p>
      ) : null}
      <p className="meta" data-testid={`${prefix}-meta`}>
        {formatEventMetaLine(event)}
      </p>
    </div>
  );
}
